"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRanges = void 0;

var _words = _interopRequireDefault(require("lodash/words"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extendChunkedArray = function extendChunkedArray(chunksPos, chunk, key) {
  var prevChunkPos = chunksPos[key - 1] || [0, -1];
  chunksPos.push([prevChunkPos[1] + 1, prevChunkPos[1] + chunk.length + 1]);
  return chunksPos;
};

var splitByDots = function splitByDots(text) {
  return (0, _words.default)(text, /[^.]+/g);
};
/**
 * @description
 * It returns ranges from specified text
 * @Function
 *
 * @name skybase-components.sb-ipv4-input.utils#getRanges
 * @param {String} text
 * @return {Array.<skybase-components.sb-ipv4-input.utils#Range>}
 */


var getRanges = function getRanges(text) {
  return splitByDots(text).reduce(extendChunkedArray, []);
};

exports.getRanges = getRanges;
//# sourceMappingURL=get-ranges.js.map